export { UploadFiles } from './UploadFile'
export type { IUploadFileModelProps } from './UploadFile.model'
